module.exports = __webpack_public_path__ + "static/media/error-icon.9abd988e.png";